import { Component } from '@verndale/core';
import { scrollTo } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.calculateContentPosition();
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    scrollTo(0);
  }

  handleScroll() {
    this.calculateContentPosition();
  }

  calculateContentPosition() {
    const visiblePosition = window.pageYOffset > window.innerHeight;

    if (!visiblePosition) {
      this.el.style.opacity = '0';
      this.el.style.visibility = 'hidden';
    } else {
      this.el.style.opacity = '1';
      this.el.style.visibility = 'visible';
    }
  }
}

export default Module;
